module.exports = __webpack_public_path__ + "img/xmbanner.a2023945.jpg";